import { useContext } from 'react';
import { ServiceContext } from '@/contexts/ServiceContext';
import { invariant } from '@/utils/invariant';

export function useServices() {
  return invariant(useContext(ServiceContext), 'useServices must be used inside <ServiceProvider>.');
}
